
import React, { useState, useEffect } from 'react';
import { usePartsFilter } from '@/hooks/use-parts-filter';
import { useUserPreferences } from '@/hooks/filters/use-user-preferences';
import { usePartsData } from '@/hooks/filters/use-parts-data';
import PartsLayout from '@/components/PartsLayout';
import FilterSidebar from '@/components/FilterSidebar';
import PartsContent from '@/components/PartsContent';

const Parts = () => {
  // View mode state
  const [viewMode, setViewMode] = useState<"grid" | "table">("grid");
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  // Get filter state and functions
  const {
    selectedCategory,
    setSelectedCategory,
    selectedSubcategory,
    setSelectedSubcategory,
    activeFilters,
    toggleFilter,
    searchQuery,
    setSearchQuery,
    minStarRating,
    setMinStarRating,
    sortBy,
    setSortBy
  } = usePartsFilter();

  // Get user preferences - fix the destructuring to match the actual hook return
  const { 
    minStarRating: prefMinStarRating,
    setMinStarRating: setPrefMinStarRating,
    viewMode: prefViewMode,
    setViewMode: setPrefViewMode
  } = useUserPreferences();

  // Get parts data - fix the parameter to match the hook signature
  const { 
    allParts, 
    isLoading
  } = usePartsData(false); // Pass boolean as expected

  // Create mock filtered parts for now
  const filteredParts = allParts || [];
  const isSupabaseConnected = false;

  // Toggle sidebar
  const toggleSidebar = () => {
    setSidebarExpanded(!sidebarExpanded);
  };

  // Create sidebar component
  const sidebar = (
    <FilterSidebar
      selectedCategory={selectedCategory}
      setSelectedCategory={setSelectedCategory}
      selectedSubcategory={selectedSubcategory}
      setSelectedSubcategory={setSelectedSubcategory}
      activeFilters={activeFilters}
      toggleFilter={toggleFilter}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      totalPartsCount={allParts.length}
      minStarRating={minStarRating}
      setMinStarRating={setMinStarRating}
    />
  );

  return (
    <PartsLayout
      viewMode={viewMode}
      setViewMode={setViewMode}
      sidebar={sidebar}
      sidebarExpanded={sidebarExpanded}
      toggleSidebar={toggleSidebar}
    >
      <PartsContent
        isSupabaseConnected={isSupabaseConnected}
        isLoading={isLoading}
        filteredParts={filteredParts}
        viewMode={viewMode}
        activeFilters={activeFilters}
        sortBy={sortBy}
        setSortBy={setSortBy}
      />
    </PartsLayout>
  );
};

export default Parts;
